import { router } from "@inertiajs/react";
import { useMutation } from "@tanstack/react-query";
import { mutateAdCreate } from "./mutateAdCreate";


// TODO: Refactor to avoid repetitive code in both implementations.
export const actionsTemplateCard = (adId) => {


    const mutation = useMutation({
        mutationKey: ['action-template-card', adId],
        mutationFn: async (params) => {
            const res = await axios.get(route('studio.editor.api.showcases.index'), {
                params
            });
            return res;
        },
        onError: async (res) => {
            console.log(res);
        }
    });

    const createAdMutation = mutateAdCreate();

    const createEmptyFromShowcase = () => mutation.mutate({ id: adId }, {
        onSuccess: ({ data }) => {
            createAdMutation.mutate({
                banner_ids: [data[0].ad_banner_formats[0].banner_format_id],
                tech_type: data[0].ad_banner_formats[0].tech_type,
                name: ''
            }, {
                onSuccess: ({ data }) => {
                    router.visit(route('studio.ad_builder.edit', { ad: data?.ad?.id }), {
                        preserveState: true,
                        replace: true
                    });
                }
            });
        },
    });

    const createCloneFromShowcase = () => mutation.mutate({ id: adId, copy: 1 }, {
        onSuccess: async ({ data }) => {
            await axios.put(route('studio.editor.api.ads.update', { ad: data.id }), { 
                name: '',
                banner_ids: [
                    data?.banner_formats?.[0]?.id || null
                ],
            });

            router.visit(route('studio.ad_builder.edit', { ad: data.id }), {
                preserveState: true,
                replace: true
            });
        }
    });

    return { createEmptyFromShowcase, createCloneFromShowcase }

}